<template>
  <div class="subpage-dashboards subpage-billing-payment--dashboard">
    <h1 class="my-account__title gds-space-stack-l subpage-dashboards--left-spacer">Billing &amp; Payment</h1>
    <div class="my-account__payment-nav gds-flex-container gds-flex-container--left subpage-dashboards--left-spacer">
      <router-link to="/billing" class="my-account__payment-nav-item" :class="{ 'active': subTab === '/billing' }">Overview</router-link>
      <router-link to="/report" class="my-account__payment-nav-item" :class="{ 'active': subTab === '/report' }">Billing Report</router-link>
      <router-link to="/preferences" class="my-account__payment-nav-item" :class="{ 'active': subTab === '/preferences' }">Billing Preferences</router-link>
      <router-link to="/saved-payments" class="my-account__payment-nav-item" :class="{ 'active': subTab === '/saved-payments' }">Saved Payments</router-link>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: "SubpageBillingPayment",
  components: {
  },
  data() {
    return {
    };
  },
  computed: {
    subTab() {
      return this.$route.path;
    },
  },
  async mounted() {
  },
  methods: {
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>